import SubmitResultPanel from './SubmitResultPanel'

export default SubmitResultPanel
